const $j = (typeof window !== 'undefined' && window.$j) || (() => {});

export function mobile() {
    if (!$j('#site-overlay').length) {
        $j('body').append('<div id="site-overlay"></div>');
        $j('.hamburger').click(function () {
            $j(this).toggleClass('is-active');
            if (!$j('body.oc-open').length) {
                $j('#nav, #site-overlay').fadeIn(200);
                $j('body').addClass('oc-open');
            } else {
                $j('#nav, #site-overlay').fadeOut(200);
                $j('body').removeClass('oc-open');
            }
        });
        $j('#oc').click(function () {
            if (!$j('body.oc-open').length) {
                $j('#nav, #site-overlay').fadeIn(200);
                $j('body').addClass('oc-open');
            } else {
                $j('#nav, #site-overlay').fadeOut(200);
                $j('body').removeClass('oc-open');
            }
        });
        $j('#site-overlay').click(function () {
            $j('#oc').click();
        });
    }
}
